/**
 * OwnerAvatar — small colored badge with the owner's initial. Used on
 * partner-owned calendar events so a glance identifies who owns what
 * without opening the detail modal.
 */

import React from 'react';
import { User } from '@/infra/types/domain';
import { getUserColor } from '@/features/household/selectors';

export interface OwnerAvatarProps {
  ownerId: string;
  users: User[];
  size?: 'sm' | 'md';
}

function initialOf(name: string | undefined | null): string {
  if (!name) return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  return trimmed.charAt(0).toUpperCase();
}

export function OwnerAvatar({ ownerId, users, size = 'md' }: OwnerAvatarProps) {
  const user = users.find((u) => u.id === ownerId);
  const name = user?.display_name ?? user?.email ?? null;
  const color = getUserColor(users, ownerId);
  const cls = `calendar__event-owner-avatar calendar__event-owner-avatar--${size}`;
  return (
    <span
      className={cls}
      style={{ backgroundColor: color }}
      aria-label={name ? `Owned by ${name}` : 'Owned by partner'}
      title={name ?? undefined}
    >
      {initialOf(name)}
    </span>
  );
}
